module.exports = __webpack_public_path__ + "img/cp4-3.b0b59b53.jpg";